function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable import/no-cycle */
import React from "react";
import Drawer from "../Drawer";
import ListSearchFilters from "./ListSearchFilters";
const ListSearchFiltersDrawer = _ref => {
  let {
    anchor = "left",
    open = false,
    onClose = _e => {},
    ListSearchFiltersProps
  } = _ref;
  const refSearchFitlers = React.useRef(null);
  return /*#__PURE__*/React.createElement(Drawer, {
    sx: {
      width: 400,
      flex: 1,
      display: "flex",
      maxWidth: 400
    },
    anchor: anchor,
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(ListSearchFilters, _extends({}, ListSearchFiltersProps, {
    ref: refSearchFitlers
  })));
};
export default ListSearchFiltersDrawer;